<template>
  <CreateAuthComp></CreateAuthComp>
</template>
<script>
import CreateAuthComp from "../../components/Authorization/CreateAuthorization.vue";

export default {
  name: "Create Authorizations",
  components: { CreateAuthComp },
  computed: {},
  mounted() {},
};
</script>
